import { render } from "./tech-specs.vue?vue&type=template&id=f4d912d4"
import script from "./tech-specs.vue?vue&type=script&lang=js"
export * from "./tech-specs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__